import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span>{{@value}}</span>\n<span class=\"ui inverted black text\">{{@unit}}</span>", {
  moduleName: "ui-kit/components/value-with-unit/index.hbs"
});